import React from 'react'

export default ({ header, value, onChangeText, prop, multiline, type = 'text', viewOnly, ...props }) => {
    const handleChange = (v) => onChangeText(prop, v.target.value);

    return (
        <div className="">
            <span htmlFor={prop}>{header}</span>
            {!!viewOnly && <label>: {value}</label>}
            {!multiline && !viewOnly && (
                <input
                    {...props}
                    type={type}
                    onChange={handleChange}
                    onInput={handleChange}
                    onBlur={handleChange}
                    value={value || ''}
                    className="form-control"
                    id={prop}
                    placeholder={header}
                />
            )}
            {multiline && !viewOnly && (
                <textarea
                    {...props}
                    onChange={handleChange}
                    onInput={handleChange}
                    onBlur={handleChange}
                    value={value || ''}
                    className="form-control"
                    id={prop}
                    rows="3"
                    placeholder={header}
                />
            )}
        </div>
    );
}
